<div class="wrapper__headerComponent container my-5">
  <div class="contenedor-tabla w-100">
    <div class="d-flex flex-row justify-content-between mb-5">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{'gestion solicitudes-pj.titulo' | translate}}
      </h2>
      <!-- Filtro de búsqueda por NIT -->
      <div class="d-flex align-items-center"
           *ngIf="mostrarSolicitudes">
        <button
          class="btn btn-actions btn-just-icon p-0 mx-1 btn-sm hvr-shrink"
          type="button"
          aria-label="Buscar">
          <i class="fa fa-search fa-lg" aria-hidden="true"></i>
        </button>
        <input
          class="form-control"
          (blur)="listarSolicitudes(nit)"
          [placeholder]="'gestion solicitudes-pj.nit' | translate"
          [(ngModel)]="nit"/>
      </div>
    </div>
    <app-table
      *ngIf="mostrarSolicitudes"
      [columnas]="columnasSolicitudes"
      [datos]="solicitudes"
      [acciones]="accionesSolicitudes"
      (eventoAccion)="acciones($event)"
      [paginacion]="true"
      [paginaActual]="paginaActual"
      [totalPaginas]="totalPaginas"
      [tamano]="tamanoPagina"
      (evento)="filtrar($event)">
    </app-table>
    <!-- Botón volver -->
    <div class="header" *ngIf="!this.mostrarSolicitudes">
      <button class="close-button" (click)="volver(true)" aria-label="Cerrar">&times;</button>
    </div>
    <!-- Verificación de solicitud -->
    <app-form
      *ngIf="verificarSolicitud"
      [tresColumnas]="true"
      [fields]="camposVerificacion"
      [title]="'gestion solicitudes-pj.verificacion-solicitud' | translate"
      [sumbitButtonText]="'gestion solicitudes-pj.verificar-info' | translate"
      (submitAction)="capturarVerificarForm($event)">
    </app-form>
    <!-- Datos observatorio -->
    <app-form
      *ngIf="registrarObservatorio"
      [fields]="camposObservatorio"
      [title]="'gestion solicitudes-pj.registro-datos' | translate"
      [sumbitButtonText]="'gestion solicitudes-pj.guardar' | translate"
      (changedControl)="validarFecha($event)"
      (submitAction)="capturarObservatorioForm($event)">
    </app-form>
    <!-- Verificar correo -->
    <app-form
      *ngIf="verificarCorreo"
      [fields]="campoAprobacion"
      [title]="'gestion solicitudes-pj.aprobacion' | translate"
      [sumbitButtonText]="'gestion solicitudes-pj.enviar-enlace' | translate"
      (submitAction)="capturarVerificarCorreoForm($event)">
    </app-form>
    <!-- Rechazo de la solicitud -->
    <app-form
      *ngIf="rechazarSolicitud"
      [fields]="camposRechazo"
      [title]="'gestion solicitudes-pj.rechazo' | translate"
      [sumbitButtonText]="'gestion solicitudes-pj.enviar' | translate"
      (changedControl)="agregarValidaciones($event)"
      (submitAction)="capturarRechazarForm($event)">
    </app-form>
  </div>
</div>
<!-- Modal documentos -->
<div class="modal-container">
  <button
    id="modalListarDocumentos"
    #modalListarDocumentos
    data-bs-toggle="modal"
    data-bs-target="#modalDocumentos"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalDocumentos"
    tabindex="-1"
    aria-labelledby="modalDocumentosLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header modal-header-govco">
          <h5 class="modal-title h5-tipografia-govco" id="modalDocumentosLabel">
            {{ 'gestion solicitudes-pj.adjuntos' | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body modal-body-govco">
          <app-table
            [columnas]="columnasDocumentos"
            [datos]="documentos"
            [paginacion]="false"
            [multipleSelection]="true"
            (selectedItemsChange)="capturarArchivos($event)"
          ></app-table>
        </div>
        <div class="modal-footer modal-footer-govco">
          <button
            [disabled]="idsArchivos.length <= Constants_solicitudes.CERO"
            type="button"
            class="btn btn-primary"
            (click)="descargarArchivos()"
            aria-label="Descargar archivos">
            {{ 'descargar' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
